import { inject, Injectable } from "@angular/core";
import { DateTime } from "luxon";
import { Observable } from "rxjs";
import {
  MeterUsage,
  MeterUsageAdapter,
} from "src/app/core/models/meter-usage.model";
import { HydraoApiService } from "src/app/core/services/core/hydrao-api.service";

@Injectable({
  providedIn: "root",
})
export class MeterUsageService extends HydraoApiService<MeterUsage> {
  private meterUsageAdapter: MeterUsageAdapter = inject(MeterUsageAdapter);

  public getUsageForStore(meterUuid: string, from: DateTime, to: DateTime) {
    let url = `/meters/${meterUuid}/stats/by-use?`;
    url += `from=${from.toUTC().toISO()}`;
    url += `&to=${to.toUTC().toISO()}`;

    return this.get(url, this.meterUsageAdapter) as Observable<MeterUsage>;
  }
}
